import Special from "./special/main.es6";

//specialページ汎用
const special = new Special();
